import script from "./UploadComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadComponent.vue?vue&type=script&lang=ts&setup=true"

import "./UploadComponent.vue?vue&type=style&index=0&id=411fd69e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-411fd69e"]])

export default __exports__